var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-create main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("pos.completion_status"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/dashboard",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/anchor/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/purchase-orders",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("pos.po", 2)))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/supplier/purchase-orders",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("pos.po", 2)))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/anchor/purchase-orders",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("pos.po", 2)))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v(_vm._s(_vm.$t("pos.completion_status"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("SinglePurchaseOrderRow", { attrs: { fetchData: _vm.fetchData } }),
      _vm._v(" "),
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            data: _vm.itemStatus,
            "show-filter": false,
            "table-class": "table",
          },
        },
        [
          _c("table-column", {
            attrs: { label: _vm.$t("items.name"), show: "name" },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("items.part_number"), show: "part_number" },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("items.unit"), show: "unit_name" },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("items.price"), show: "price" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("items.price")) + " "),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(row.price, _vm.defaultCurrency)
                        ),
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("items.quantity"), show: "quantity" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("items.quantity")) + " "),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: { innerHTML: _vm._s(row.quantity) },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("items.delivered_quantity"),
              show: "delivered_quantity",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(
                        " " + _vm._s(_vm.$t("items.delivered_quantity")) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: { innerHTML: _vm._s(row.deliveryQuantity) },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("items.remaining_quantity"),
              show: "deliveryNote_remainig_quantity",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }